module.exports = __webpack_public_path__ + "436d184fb073e5ea5489e9a58095bbe2.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/lazy-9.png
// module id = 2236
// module chunks = 0